import { render, staticRenderFns } from "./VehiclesSection.vue?vue&type=template&id=5a8a0156&scoped=true"
import script from "./VehiclesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehiclesSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VehiclesSection.vue?vue&type=style&index=0&id=5a8a0156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a0156",
  null
  
)

export default component.exports